import React from 'react';
import * as actions from '../../Actions/bankfeeds';
import Spinner from '../UI/Spinner/spinner';
import css from './bfm.css';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  
  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  
  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  
  const headCells = [
    { id: 'bankName', numeric: false, disablePadding: false, label: 'Bank' },
    { id: 'bankfeedId', numeric: false, disablePadding: false, label: 'Account Number' },
  ];
  
  function EnhancedTableHead(props) {
    const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };
  
    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
              Select
          </TableCell>
          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={'left'}
              padding={headCell.disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }
  
  EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      width: '90%',
      margin: 'auto'
    },
    paper: {
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    table: {
      width: '100%',
      '& td': {
        fontFamily: 'inherit',
      }
    },
    tableCell: {
      background: 'whitesmoke'
    },
    tableRow: {
      '&$selected:hover': {
        backgroundColor: theme.palette.action.hover
      },
      '&:nth-of-type(odd)': {
        backgroundColor: 'white',
      },
      '&:nth-of-type(even)': {
        backgroundColor: 'rgba(192,192,192,0.08)',
      }, 
    },
    selected: {},
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
  }));
  
let ConnectFeeds = (props) => {
    const { onClose, bankfeeds } = props;

    const classes = useStyles();
    const [rows, setRows] = React.useState([]);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('bankName');
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
    const loading = !bankfeeds.apiError && !bankfeeds.loadCompleted;
    const colSpan = headCells.length + 1; // number of columns including checkbox column.

    const onReLink = bankfeedIds => {
      const feeds = rows.reduce((allFeeds, bankfeed) => {
        if (bankfeedIds.includes(bankfeed.bankfeedId)) allFeeds.push(bankfeed);
        return allFeeds;
      }, [])
      props.onReLink(feeds);
    }

    React.useEffect(() => {
        setRows(bankfeeds.bankfeeds || []);
        setPage(0);
      }, [bankfeeds.bankfeeds])
    
      React.useEffect(() => {
        props.getBankFeeds();
        return () => props.clearBankfeeds();
      }, [])
  
    const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    };
  
    const handleClick = (event, key) => {
      const selectedIndex = selected.indexOf(key);
      let newSelected = [];
  
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, key);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          selected.slice(0, selectedIndex),
          selected.slice(selectedIndex + 1),
        );
      }
  
      setSelected(newSelected);
    };
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
  
    const isSelected = (key) => selected.indexOf(key) !== -1;
  
    return (
        <div className={css.w600}>
            <div className={[css.textCenter, css.mb25, css.mt0].join(' ')}>
                {/* The below feeds already exit under your Account, do you want to connect <br /> Fast Coding to these feeds */}
                The below feeds have previously been created by your account, <br /> and are not currently linked to another Fast Coding product
            </div>
            <div className={css.mb25}>
                <div className={classes.root}>
                    <Paper className={classes.paper}>
                        <TableContainer>
                        <Table
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            size={'small'}
                            aria-label="enhanced table"
                        >
                            <EnhancedTableHead
                            classes={classes}
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                            />
                            <TableBody>
                            {(rows.length === 0 || loading) ? 
                                <TableRow style={{ height: (33 * 5) }}>
                                    <TableCell colSpan={colSpan} style={{ textAlign: 'center' }}>
                                    { loading ? <Spinner small={true} /> : 'No bankfeed found' }
                                    </TableCell>
                                </TableRow>
                                : stableSort(rows, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                const isItemSelected = isSelected(row.bankfeedId);
                                const labelId = `enhanced-table-checkbox-${index}`;

                                return (
                                    <TableRow
                                      hover
                                      onClick={(event) => handleClick(event, row.bankfeedId)}
                                      role="checkbox"
                                      aria-checked={isItemSelected}
                                      tabIndex={-1}
                                      key={row.bankfeedId}
                                      selected={isItemSelected}
                                      classes={{ selected: classes.selected }}
                                      className={classes.tableRow}>
                                        <TableCell align={'center'} padding="checkbox">
                                            <Checkbox
                                            // color="default"
                                            checked={isItemSelected}
                                            inputProps={{ 'aria-labelledby': labelId }}
                                            />
                                        </TableCell>
                                        <TableCell id={labelId} scope="row">
                                            {row.bankName}
                                        </TableCell>
                                        <TableCell>{row.accountNumber}</TableCell>
                                    </TableRow>
                                );
                                })}
                            {rows.length > 0 && emptyRows > 0 && (
                                <TableRow style={{ height: 33 * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                            </TableBody>
                        </Table>
                        </TableContainer>
                        <TablePagination
                        rowsPerPageOptions={[10]}
                        component="div"
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </Paper>
                </div>
                <div className={css.openBanking} onClick={() => localStorage.setItem('isOpenBanking', true)}>Open Banking</div>
            </div>
            <div className={[css.pb10, css.dividerDarkGrey].join(' ')}>
            <Button type="button" variant="contained" onClick={onClose}>
              Close
            </Button>
            <Button
              type="submit"
              variant="contained"
              className={[css.mr10, css.floatRight].join(' ')}
              color="primary"
              disabled={selected.length === 0}
              onClick={() => onReLink(selected)}>
              Save
            </Button>
          </div>
        </div>
        )
}


function mapStateToProps(state) {
    return {
      bankfeeds: state.bankfeeds
    };
  }
  
export default connect(mapStateToProps, actions)(ConnectFeeds);


// WEBPACK FOOTER //
// ./src/components/FeedManagment/ConnectFeeds.js